/** Converts date to yyyy.MM.dd HH:mm:ss format */
export const convertDateToDisplay = (date: Date | undefined, timeBreakDown?: string | undefined) =>
{
    if (!date) return "Ismeretlen dátum";

    const displayedDate = [
        date.getFullYear(),
        (date.getMonth() + 1).toString().padStart(2, "0"),
        date.getDate().toString().padStart(2, "0")
    ];

    if (timeBreakDown === "ora")
    {
        // 2022.05.09 10:00
        return displayedDate.join(".") + " "
               + [date.getHours(),
                   "00"
               ].join(":");
    }
    else if (timeBreakDown === "nap")
    {
        // 2022.05.09
        return displayedDate.join(".");
    }
    else
    {
        // we need two digits like 08:08:08
        return displayedDate.join(".") + " "
               + [("0" + date.getHours()).slice(-2),
                   ("0" + date.getMinutes()).slice(-2),
                   ("0" + date.getSeconds()).slice(-2)
               ].join(":");
    }
};

